import styled from '@emotion/styled';

import {
  animation,
  breakpoints,
  colors,
  fontWeight,
} from '@datacamp/waffles-tokens';

import ImgTriangle from 'images/featured/triangle.svg';

export const A = styled.a`
  color: ${colors.grey};
  display: block;
  font-weight: ${fontWeight.regular};
  margin: -120px 16px 0;

  h3 {
    margin-top: 12px;
    transition: color ${animation.transition};
  }

  .block {
    overflow: hidden;
    padding: 24px;
    width: 100%;
  }

  p:last-of-type {
    margin-bottom: 0;
  }

  &:active,
  &:focus,
  &:hover {
    border-color: transparent;
    color: ${colors.grey};

    h3 {
      color: ${colors.primary};
    }
  }

  @media screen and (min-width: ${breakpoints.sm}) {
    margin: -150px 16px 0;

    .block {
      display: flex;
      min-height: 300px;
      padding: 0;
    }
  }

  @media screen and (min-width: ${breakpoints.lg}) {
    margin: -150px 0 0;
  }
`;

export const Content = styled.div`
  @media screen and (min-width: ${breakpoints.sm}) {
    align-items: center;
    background: ${colors.white};
    display: flex;
    position: relative;
    padding: 48px 24px 48px 1px; /* 1px */
    width: 50%;
    z-index: 10;

    &::before {
      background: url(${ImgTriangle}) no-repeat right top;
      background-size: auto 100%;
      bottom: -1px;
      content: '';
      position: absolute;
      right: calc(100% - 1px);
      top: 0;
      width: 100%;
    }
  }
`;

export const Flex = styled.div`
  .block:hover {
    transition: unset;
  }

  @media screen and (min-width: ${breakpoints.sm}) {
    display: flex;
    overflow: hidden;
    width: 100%;

    &:hover {
      .photoContainer {
        transform: scale(1.1);
      }
    }
  }
`;

export const PhotoContainer = styled.div`
  background-size: cover;
  flex-grow: 1;
  transition: transform ${animation.transition};
`;

export const PhotoWrapper = styled.div`
  display: none;

  @media screen and (min-width: ${breakpoints.sm}) {
    display: flex;
    overflow: hidden;
    width: 50%;
  }
`;
